import React from "react";
import Button from "../button/button.component";
import { CourseInsert } from "../../@types/course.interface";

interface IProps {
    course: CourseInsert;
    handleClick: (evt: any) => void;
    handleChange: (evt: any, name: string) => void;
}

const CourseForm = ({course,handleClick,handleChange}:IProps) => {

    return (
        <div className="quiz">
            <div className="title">
                <h2 className="heading">
                   Create Course
                </h2>
            </div>
            <form className="quiz__form" action="#" method="post">
                <div className="quiz__form__input">
                    <div className="quiz__form__input__label">
                        <span>Course name</span>
                    </div>
                    <input
                        className="quiz__form__input__number"
                        type="text"
                        value={course.course_name}
                        placeholder="ex: COMP6047 - Algorithm and Programming"
                        onChange={(evt) => handleChange(evt, "course_name")}
                    />
                </div>
                <div className="quiz__form__button">
                    <Button
                        className="dark"
                        type="submit"
                        onClick={handleClick}
                    >
                        Create
                    </Button>
                </div>
            </form>
        </div>
    );
}

export default CourseForm;